// Shared payment-method label map.
// Phase 65 D-04: source of truth for provider display name + address layout.
// Lifted from frontend/src/components/AmbassadorDataModal.jsx:156-160 so
// InvoicesView, ContractCard, and AmbassadorDataModal share one vocabulary.
//
// Lowercase keys (`paypal`/`payoneer`/`crypto`) match the backend whitelist
// (backend/src/routes/invoices.js PAYMENT_METHOD_WHITELIST, Plan 65-03)
// and the ambassador-form Zod enum (ambassador-form/src/schemas/ambassador.ts:63).
export const PAYMENT_LABELS = {
  paypal:   'PayPal',
  crypto:   'Cryptocurrency',
  payoneer: 'Payoneer',
  garna:    'Garna',
};

/**
 * Returns the renderable parts for the "Способ оплаты" cell / row.
 * Source-of-truth code = contract.paymentMethod (Phase 65 D-01); ambassador's
 * collection-side value is the fallback for legacy rows where the contract
 * was completed before D-02 backfill ran.
 *
 * @param {{paymentMethod?: string|null} | null | undefined} contract
 * @param {{paymentMethod?: string|null, paymentAddress?: string|null} | null | undefined} ambassador
 * @returns {{ providerLabel: string, addressDetail: string }}
 */
export function formatPaymentMethod(contract, ambassador) {
  const code = contract?.paymentMethod || ambassador?.paymentMethod || null;
  if (!code) return { providerLabel: '—', addressDetail: '' };
  return {
    providerLabel: PAYMENT_LABELS[code] || code,
    addressDetail: ambassador?.paymentAddress || '',
  };
}

/**
 * Per-invoice payment display — reads the invoice's OWN persisted
 * paymentMethod/paymentAddress (Phase 65 D-25 override, always NOT NULL).
 * This is what the «Способ оплаты» list filter (invoices.paymentMethod) and the
 * CSV export use; the contract/ambassador-sourced formatPaymentMethod above
 * could diverge (59 such rows in prod) and made the filter look broken.
 *
 * @param {{paymentMethod?: string|null, paymentAddress?: string|null} | null | undefined} invoice
 * @returns {{ providerLabel: string, addressDetail: string }}
 */
export function formatInvoicePayment(invoice) {
  const code = invoice?.paymentMethod || null;
  if (!code) return { providerLabel: '—', addressDetail: '' };
  return {
    providerLabel: PAYMENT_LABELS[code] || code,
    addressDetail: invoice?.paymentAddress || '',
  };
}
